module.exports = require("./bo.d.ts");